import script from "./AssessmentSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentSection.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentSection.vue?vue&type=style&index=0&id=0a1edb6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1edb6c"]])

export default __exports__